import { RoleRecord } from '@root/globalTypes';
import { PrimaryRole } from '@services/dropdowns/users/types';
import { fullAccessRoles } from './constants';

export const getAccess = (primaryRole: PrimaryRole, roles: RoleRecord[]) => {
  const adminAccess = () => {
    if (primaryRole !== 'office') return false;
    return roles.some((el) => el.name.toLowerCase() === 'administrator');
  };

  const fullAccess = () => {
    if (primaryRole !== 'office') return false;
    return roles.some((el) => fullAccessRoles.includes(el.name.toLowerCase()));
  };

  const cadAccess = () => {
    if (primaryRole !== 'office') return false;
    if (roles.length > 1) return false;
    return roles.some((el) => el.name.toLowerCase() === 'cad_technician');
  };

  const readOnlyAccess = () => {
    if (primaryRole !== 'office') return false;
    if (roles.length > 1) return false;
    return roles.some((el) => el.name.toLowerCase() === 'read_only');
  };

  const fieldUserAccess = () => {
    return primaryRole === 'field_user';
  };

  return {
    admin: adminAccess(),
    full: fullAccess(),
    cad: cadAccess(),
    readOnly: readOnlyAccess(),
    fieldUser: fieldUserAccess(),
  };
};
